export function draw(
  definition,
  absolutePoint,
  itemViews,
  interaction,
  methods,
) {
  //user's start callback
  const onStartDrawing = definition.onStartDrawing
  if (onStartDrawing) onStartDrawing()

  //search mount item
  const mountItem = definition.getMountItem()

  //search index of mount item
  const position = methods.getItemViewPosition(mountItem) + 1
  if (position < 1) return null

  //create new itemView
  const currentItemView = {
    type: 'default',
    entity: definition.entity,
    deleted: false,
    position: position,
    boundary: {
      x: absolutePoint.x,
      y: absolutePoint.y,
      width: 0,
      height: 0,
      angle: 0,
    },
    params: interaction.params ? { ...interaction.params } : {},
  }

  itemViews.forEach(item => {
    if (!item.deleted && item.position >= position) item.position += 1
  })

  itemViews.push(currentItemView)

  //set history item
  methods.setHistory({
    type: 'draw',
    itemView: currentItemView,
    prevValue: false,
  })

  //stop checking of interations
  return {
    itemViews: [...itemViews],
    currentItemView,
    status: 'drawing',
  }
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseDown/draw.js